module.exports = __webpack_public_path__ + "img/12.d75cf6b.png";